import React, { useState, useRef } from "react";
import "./RelatedInterest.css"; 
import "./StatusDownloadCard.css"
import { toImageKitURL, trackEvent } from "./UtilsFunction";
import { generateCaption } from "./GetImageColors";
import { TbBadgeHdFilled } from "react-icons/tb";
import { toast } from "react-toastify";
import { FiDownload } from "react-icons/fi";
import { AiFillEye } from "react-icons/ai";


export function StatusDownloadCard({ images, imageCategoryName, userIntent   }) {

  // const [imageLoaded, setImageLoaded] = useState({});
  const [imageStates, setImageStates] = useState({});
  const cardRefs = useRef({}); // store refs by id
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const [downloadState, setDownloadState] = useState({});

  if (!images?.length) return null;

// async function downloadImage(img, uid) {
//     const node = cardRefs.current[uid];
    
//     console.log("going to download 1", node, window.htmlToImage)
//     if (!node || !window.htmlToImage) return;
// console.log("going to download 2")
//     try {
//       const dataUrl = await window.htmlToImage.toPng(node, {
//         pixelRatio: 2, // high quality
//         cacheBust: true
//       });

//       const link = document.createElement("a");
//       link.href = dataUrl;
//       link.download = `${imageCategoryName || "status"}.png`;
//       link.click();

//     } catch (err) {
//       console.error("Download failed:", err);
//     }
// }

async function shareImage(dataUrl, fileName) {
  const blob = await (await fetch(dataUrl)).blob();
  const file = new File([blob], fileName, { type: blob.type });

  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    await navigator.share({
      title: "BrowseNext Status",
      files: [file],
    });
  } else {
    alert("Sharing not supported on this device");
  }
}

function handleStatusImageClick(actiononElement, img) {
  if (localStorage.getItem("BN_EXCLUDE_ANALYTICS") === "true") return;

  trackEvent(actiononElement, {
    img_id: img?.id,
    tags: img?.tags || "No tags",
    image_url: img?.largeImageURL || img?.webformatURL,
    category: imageCategoryName || "unknown",
    page_path: window.location.pathname,
    component: "status_download_card"
  });
}





function showPreview(img) {
handleStatusImageClick("click_story_preview_button", img)
  toast.info("Story preview comming soon");
  
}





async function downloadImage(img, uid) {
  const node = cardRefs.current[uid];
  if (!node || !window.html2canvas) return;

  handleStatusImageClick("status_download_button_click", img);
node.style.borderRadius = "0px";
node.style.overflow = "hidden";

try{
    // 👉 show "Downloading..."
  setDownloadState(prev => ({
    ...prev,
    [uid]: "loading"
  }));

  const rect = node.getBoundingClientRect();

  const targetWidth = 1080;
  const targetHeight = 1920;

  // ✅ calculate scale properly
  const scale = targetWidth / rect.width;

  // ✅ capture with scale
  const canvas = await window.html2canvas(node, {
    scale: scale,
    useCORS: true,
    backgroundColor: null
  });

  node.style.borderRadius = "";
node.style.overflow = "";

  // ✅ force exact story size
  const finalCanvas = document.createElement("canvas");
  finalCanvas.width = targetWidth;
  finalCanvas.height = targetHeight;

  const ctx = finalCanvas.getContext("2d");

  

  // center image (important for aspect ratio)
  ctx.drawImage(canvas, 0, 0, targetWidth, targetHeight);

  const dataUrl = finalCanvas.toDataURL("image/png");

  if ((userIntent?.tagType !== "background" && userIntent?.tagType !== "wallpaper" && isMobile)) {
    await shareImage(
      dataUrl,
      `${imageCategoryName || "status"}-story.png`
    );
    return;
  }

  const link = document.createElement("a");
  link.href = dataUrl;
  link.download = `BrowseNext-${imageCategoryName || "story"}-status.png`;
  link.click();
    // 👉 show "Downloaded"
    setDownloadState(prev => ({
      ...prev,
      [uid]: "done"
    }));

    // 👉 reset after 2 sec
    setTimeout(() => {
      setDownloadState(prev => ({
        ...prev,
        [uid]: "idle"
      }));
    }, 2000);


}catch(error){
  console.log("download faild ", error)
  if(isMobile){
    
    toast.error("Image couldn’t be share now. Please try again.");

    
  }else{
    setDownloadState(prev => ({
       ...prev,
       [uid]: "idle"
     }));
 
    toast.error("Story couldn’t be downloaded. Please try again.");

  }
}
}

 


//   async function  downloadImage(img, uid) {
//   handleStatusImageClick("status_download_button_click", img);

//   const imageUrl = img.largeImageURL || img.webformatURL;
//   const fileName = `BrowseNext-${imageCategoryName || "story"}-status`;


//   // const downloadUrl = `http://localhost:3001/api/download?url=${encodeURIComponent(imageUrl)}&name=${encodeURIComponent(fileName)}`;

//   const downloadUrl = `/api/download?url=${encodeURIComponent(imageUrl)}&name=${encodeURIComponent(fileName)}`;

  
//     const link = document.createElement("a");
//     link.href = downloadUrl;    
//     link.click();

//   toast.success("📥 Image downloading...");
// }



const markFullLoaded = (uid) => {
  setImageStates(prev => {
    if (prev[uid]?.fullLoaded) return prev;
    return {
      ...prev,
      [uid]: { ...prev[uid], fullLoaded: true }
    };
  });
};

const markPreviewLoaded = (uid) => {
  setImageStates(prev => {
    if (prev[uid]?.previewLoaded) return prev;
    return {
      ...prev,
      [uid]: { ...prev[uid], previewLoaded: true }
    };
  });
};

const getHeading = () => {
  if (!userIntent) return "Download Stories for Instagram";
  // if (!userIntent) return "Ready for Instagram Stories";

  if (userIntent.tagType === "background") {
    return isMobile ? "Set as Status Background" : "Perfect for  Background Image";
  }

  if (userIntent.tagType === "wallpaper") {
    // return isMobile ? "Use as Wallpaper" : "Download HD Wallpaper";
    return isMobile ? "Use as Wallpaper" : "Perect for Wallpaper";
  }

  if (userIntent.tagType === "creative") {
    return "Download Stories for Instagram";
  }

  // return isMobile ? "Share Stories" : "Featured Instagram Stories";
  return isMobile ? "Share Stories on Instagram" : "Download Stories for Instagram";
};

function makewebformatImageUrl(image){

  console.log("previewURL for...", image.previewURL);

  return image?._source !== "pexels" ? image.previewURL.replace("_150.jpg", "_640.jpg") : image.previewURL

}

function makelargeImageUrl(image){

  return image?._source !== "pexels" ? image.previewURL.replace("_150.jpg", "_1280.jpg") : image.previewURL

}



const getSubtitle = () => {
  if (!userIntent) return "Download in Story Format •  No editing needed";

  if (userIntent.tagType === "background") {
    // return isMobile ? "Set as Status Background" : "Perfect for  Background Image";
    return 'Set as Background •  No editing needed'
  }

  if (userIntent.tagType === "wallpaper") {
    // return isMobile ? "Use as Wallpaper" : "Download HD Wallpaper";
    // return isMobile ? "Use as Wallpaper" : "Perect for Wallpaper";
    return 'Set as Wallpaper •  No editing needed'
    
  }

  if (userIntent.tagType === "creative") {
    return "Download in Story Format •  No editing needed";
    
  }

  
    // return "Photo's will Download in Story Format •  No editing needed";
    // return "Download in Story Format •  No editing needed";
    // return "Photos are waiting to download in Story Format ";
    return "Loved by Creators"
  
};

const getCTA = (uid) => {
  if (downloadState[uid] === "loading") return "Downloading...";
  if (downloadState[uid] === "done") return "Downloaded ✅";

  if (userIntent?.tagType === "background") {
    // return isMobile ? "Use as Status" : "Download Background";
    return "Download Background";
  }

  if (userIntent?.tagType === "wallpaper") {
    return isMobile ? "Set Wallpaper" : "Download HD";
  }

  if (userIntent?.tagType === "creative") {
    return isMobile ? "Share Story" : "Download Stroy";
  }

  return isMobile ? "Share Story" : "Download Story";
};

  return (
    <div className="container related-section  app_container status_section padding_lefts  max-width-full">
      {/* bg_color_container add_padding */}

      {/* <h2 className="related_heading_section mb-4">{isMobile ? 'Share on Status' :`Download Status for ${imageCategoryName || ""} `}</h2> */}

      {/* <h2 className="related_heading_section mb-4">{isMobile ? 'Share Stories on Instagram' :`Download Stories for Instagram `}</h2> */}

      <h2 className="related_heading_section m-0">{getHeading()}</h2>
        <span className="last_updated_text blog_back_heading mb-1"> {getSubtitle()} </span>

      <div className="related-row  bg-transparent">

        {images.map(img => {
          const uid = img.id || img._uid;

          return (
            <div key={uid} className="position-relative download-card-wrapper">

              {/* CLICKABLE CARD */}
           {imageStates[uid]?.previewLoaded &&  <TbBadgeHdFilled className="status_hd_icon" />} 
           
           {/* {imageStates[uid]?.previewLoaded &&  <AiFillEye  title="See Story Preview" className="status_hd_icon status_preview"           
            onClick={(e) => {
              e.stopPropagation();
              showPreview(img);
            }}

           />} */}

              <div
                ref={el => (cardRefs.current[uid] = el)}
  onClick={() => handleStatusImageClick("status_image_div_click",img)}
                className={`related-card status_card mt-2 ${
                  imageStates[uid]?.fullLoaded ? "clickable" : "disabled"
                } ${userIntent.tagType === "background" ? 'increase_width' : ''}`}
           
              >

                {/* Skeleton */}
             {!imageStates[uid]?.previewLoaded && <div className="skeleton" />}
{/* 
                <img
                  // src={img.webformatURL || img.webformatURL}
                       src={img.optimizedURL}

  srcSet={`
    ${img.previewOptimized} ${img.previewWidth}w,
    ${img.optimizedURL} ${img.webformatWidth}w,
    ${img.largeOptimized} ${img.imageWidth}w
  `}

  sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    crossOrigin="anonymous" 
                  className={`related_interest_img ${
                    imageLoaded[uid] ? "loaded" : "loading"
                  }`}
                  onLoad={() => handleImageLoad(uid)}
                    // onError={() => handleImageLoad(uid)} 
                  ref={(el) => {
                    if (el && el.complete && !imageLoaded[uid]) {
                      handleImageLoad(uid);
                    }
                  }}
                  alt={generateCaption(img)}
                  decoding="async"
                  loading="lazy"
                  
                /> */}



                <img
  src={toImageKitURL(img.previewURL, img.webformatWidth)}
  
  
  srcSet={`
    ${toImageKitURL(img.previewURL, img.previewWidth)} ${img.previewWidth}w,
    ${toImageKitURL(makewebformatImageUrl(img), img.webformatWidth)} ${img.webformatWidth}w,
    ${toImageKitURL(makelargeImageUrl(img), img.imageWidth)} ${img.imageWidth}w
  `}
  sizes="(max-width: 600px) 100vw, 50vw"

  loading="eager"          // ⭐ IMPORTANT for above-the-fold
  decoding="async"

  className="related_interest_img"

  onLoad={(e) => {
    markPreviewLoaded(uid);
    markFullLoaded(uid);
    e.currentTarget.classList.add("loaded");
  }}

  ref={(el) => {
    if (el && el.complete && !imageStates[uid]?.fullLoaded) {
      
      markFullLoaded(uid);
       
    }
  }}

  onError={(e) => {
    e.target.src = img.webformatURL;
  }}

  alt={generateCaption(img)}
/>

              </div>

           


              {/* TITLE OVERLAY (same style) */}
              <span className="related_interest_image_title three_dot download_status_image_button"      
              onClick={(e) =>{
                // e.stopPropagation();
               downloadImage(img, uid)
               }}
               style={{
  pointerEvents: downloadState[uid] === "loading" ? "none" : "auto",
  
}}
               
               >
                {/* Download */}

                {/* {isMobile ? "Share on status" : "Download"} */}

                {/* {
  isMobile
    ? "Share Story"
    : downloadState[uid] === "loading"
    ? "Downloading..."
    : downloadState[uid] === "done"
    ? "Downloaded ✅"
    : (<>
      Download Story <FiDownload className="home_seeall_icon" />
    </>)
} */}


{getCTA(uid)} {(userIntent?.tagType !== "background" && userIntent?.tagType !== "wallpaper" && isMobile) ? (<>
 
 <i className="fa-solid fa-share-nodes home_seeall_icon" />

</>) : (<>
  
<FiDownload className="home_seeall_icon" />
</>)} 


              </span>

            </div>
          );
        })}

      </div>

    </div>
  );
}


// Trending Story Vibes
// Popular Story Aesthetics
// Explore Story Moods
// Story Inspiration Packs
// Trending Visual Stories